// src/components/Molding.js

import React from 'react';
import './Molding.css';

import mold1 from '../imgs/machine.webp';
import mold2 from '../imgs/Doublestation.webp';

const moldingItems = [
  {
    title: '-Injection Molding Machine-',
    image: mold1,
    description: 'Clamping Froces From 500 To 35000 KN Hydraulic, Hybrid And Fully Electric.',
  },
  {
    title: '-Blow Molding Machine-',
    image: mold2,
    description: 'From Small Bottle To 60L Barrel extrusion And Strech Blowing.',
  },
];

const Molding = () => {
  return (
    <section className="molding-section">
      <h2 className="section-title">Molding Services</h2>
      <div className="molding-grid"    >
        {moldingItems.map((item, index) => (
          <div className="molding-card" data-aos="flip-left" key={index}>
            <div className="molding-content">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>

            <img src={item.image} alt={item.title} className="molding-img" />

          </div>
        ))}
      </div>
    </section>
  );
};

export default Molding;
